import { FC } from "preact/compat";
import { useApp } from "~/core";
import { HelpTag } from "~/core/slices/help/tags";
import { HistoryTreeNodeProps } from "./interfaces";
import { getHistoryLabel } from "./utils";
import cn from "classnames";

const HistoryTreeNode: FC<HistoryTreeNodeProps> = ({
    tag,
    node,
    history,
    padding = 0,
}) => {
    const { help } = useApp();
    const unsaved = help.admin.state(tag.tag);
    const prepublishContent = help.admin.getPrepublishContent(tag.tag);
    const isActive = node.value?.active;
    const isSelected =
        (!unsaved && node.value?.active) ||
        (unsaved && unsaved.detailedId === node.value?.detailedId) ||
        (node.value?.active && unsaved.detailedId === 0);
    const isOpenable = node.children.length > 0;
    const isPrepublish =
        prepublishContent &&
        (prepublishContent.detailedId === node.value?.detailedId ||
            (prepublishContent.detailedId === 0 && node.value?.active));

    const handleClick = () => {
        const val = node.value;

        if (!val) {
            return;
        }

        const h = history.peek().map((i) => ({
            id: i.detailedId,
            parentId: i.parent,
            diff: i.diff,
        }));
        const index = h.findIndex((i) => i.id === val.detailedId);

        if (index === -1) {
            return;
        }

        help.admin.selectRevision(tag.tag as HelpTag, val.detailedId);
    };

    return (
        <>
            <button
                type="button"
                onClick={handleClick}
                style={{
                    paddingLeft: `${(padding + 1) * 16}px`,
                }}
                className={cn(
                    "relative flex w-full items-center justify-between gap-x-2 p-2 hover:bg-gray-100",
                    isActive && "text-green-600",
                    isSelected && "bg-gray-100",
                    isPrepublish && "text-sky-700",
                )}
            >
                {isSelected && (
                    <div className="absolute bottom-0 left-0 top-0 w-2 bg-sky-500" />
                )}
                <span>{getHistoryLabel(node.value)}</span>
                {isActive && (
                    <span
                        title="Active revision"
                        className="size-2 flex-shrink-0 bg-green-600"
                    />
                )}
                {isPrepublish && (
                    <span
                        title="Prepublish revision"
                        className="size-2 flex-shrink-0 bg-sky-700"
                    />
                )}
            </button>
            {isOpenable && (
                <div>
                    {node.children.map((child) => (
                        <HistoryTreeNode
                            tag={tag}
                            history={history}
                            key={child.tag}
                            node={child}
                            padding={padding + 1}
                        />
                    ))}
                </div>
            )}
        </>
    );
};

export default HistoryTreeNode;
